import React from 'react';
import { FaFolderPlus } from 'react-icons/fa6';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';

export interface CreateFolderButtonProps {
	disabled?: boolean;
	isCreating?: boolean;
	onClick(): void;
}

export function CreateFolderButton({ disabled, isCreating, onClick }: CreateFolderButtonProps) {
	return (
		<button
			type='button'
			className='flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-400 bg-white text-sm font-semibold text-cPurple-600 shadow-sm tracking-wide whitespace-nowrap flex-shrink-0 transition-colors hover:bg-cPurple-600 hover:border-cPurple-600 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-cPurple-400 disabled:hover:text-cPurple-600'
			disabled={disabled || isCreating}
			onClick={onClick}
		>
			CZ Reimbursement
			{isCreating ? (
				<SpinningLoadingIcon className='w-3 h-3 flex-shrink-0' />
			) : (
				<FaFolderPlus className='w-3 h-3 flex-shrink-0' />
			)}
		</button>
	);
}
